import axios from "../shared/axios";

export function getReportingClient() {
  return axios.get("api/PowerBIReportingClient/Get");
}

export function rotateReportingClientSecret() {
  return axios.post("api/PowerBIReportingClient/CreateOrRotateSecret");
}

export function getToken(clientId, clientSecret) {
  const payload = { clientId, clientSecret };
  return axios.post("api/PowerBIReportingClient/GetToken", payload);
}

export function getContractGlobal() {
  return axios.get("api/PowerBIReportingClient/GetContractGlobal");
}